<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<sf-data-table ref="dataTable" :pageUnit="10" :columns="column" :rows="rows" :index="true" height="500px"> </sf-data-table>
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/UserGroupControlManagement/store/helpers';
export default {
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.commFuncList;
		},
		column() {
			return [
				{
					label: this.getMessage_('SWCC000150'),
					prop: 'commCd',
					minWidth: '80px',
					clickEvent: this.selectRow,
					highlight: true
				},
				{
					label: this.getMessage_('SWCC000151'),
					prop: 'commCdName',
					minWidth: '80px'
				},
				{
					label: this.getMessage_('SWCC000150'),
					prop: 'commCdSeq',
					minWidth: '80px'
				},
				{
					label: this.getMessage_('SWCC000152'),
					prop: 'commCdDesc1',
					minWidth: '80px'
				},
				{
					label: this.getMessage_('SWCC000152'),
					prop: 'commCdDesc2',
					minWidth: '80px'
				},
				{
					label: this.getMessage_('SWCC000209'),
					prop: 'flag1',
					minWidth: '80px'
				},
				{
					label: this.getMessage_('SWCC000146'),
					prop: 'regDt',
					minWidth: '80px'
				},
				{
					label: this.getMessage_('SWCC000005'),
					prop: 'regId',
					minWidth: '80px'
				}
			];
		}
	},
	methods: {
		...serviceMethods,
		getData() {
			this.$sf_toggleLoading(true);
			this.getCommFuncList_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message ? error.message : error
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		selectRow(row) {
			this.$emit('close', row);
		}
	},
	created() {
		this.getData();
	}
};
</script>

<style></style>
